export default __webpack_public_path__ + "static/joe-books-kids-789fd43eaf583268ad22e7a6e6d96a56.jpg";